import { OnboardingSteps } from '@/components/OnboardingTour/OnboardingTourTypes';

import { ApiUserRole } from '@/services/auth/auth.types';

const title: OnboardingSteps[0]['title'] = 'dashboard.title';

export const onboardingDashboardPage = [
  {
    title,
    target: 'page-dashboard',
    placement: 'right',
    disableScrolling: true,
    disableScrollParentFix: true,
    content: {
      title: 'dashboard.step1.title',
      message: 'dashboard.step1.message',
    },
  },
  {
    title,
    target: 'step-dashboard-2',
    content: {
      title: 'dashboard.step2.title',
      message: 'dashboard.step2.message',
    },
  },
  {
    roleList: [
      ApiUserRole.LEAD_USER,
      ApiUserRole.COMMAND_FINANCIER,
      ApiUserRole.COMPANY_FINANCIER,
      ApiUserRole.OWNER,
    ],
    title,
    target: 'step-dashboard-3',
    content: {
      title: 'dashboard.step3.title',
      message: 'dashboard.step3.message',
    },
  },
  {
    title,
    roleList: [
      ApiUserRole.LEAD_USER,
      ApiUserRole.COMMAND_FINANCIER,
      ApiUserRole.COMPANY_FINANCIER,
      ApiUserRole.OWNER,
    ],
    target: 'step-dashboard-4',
    content: {
      title: 'dashboard.step4.title',
      message: 'dashboard.step4.message',
    },
  },
] as const satisfies OnboardingSteps;
